export const INSERT_NEW_ROW = 'INSERT_NEW_ROW';
export const UPDATE_TABLE_ROWS = 'UPDATE_TABLE_ROWS';
export const EDIT_ROW_TABLE_ATIVIDADES = 'EDIT_ROW_TABLE_ATIVIDADES';
export const SET_TIPO_ALVARA = 'SET_TIPO_ALVARA';
export const UPDATE_TABLE_ATIVIDADES_EDITED_ROW =
  'UPDATE_TABLE_ATIVIDADES_EDITED_ROW';
export const INSERT_NEW_ROW_RESPONSAVEL = 'INSERT_NEW_ROW_RESPONSAVEL';
export const UPDATE_TABLE_RESPONSAVEIS_ROWS = 'UPDATE_TABLE_RESPONSAVEIS_ROWS';
export const EDIT_ROW_TABLE_RESPONSAVEIS = 'EDIT_ROW_TABLE_RESPONSAVEIS';
export const UPDATE_TABLE_RESPONSAVEIS_EDITED_ROW =
  'UPDATE_TABLE_RESPONSAVEIS_EDITED_ROW';
export const UPDATE_DOCUMENT_FORMAT_FILE = 'UPDATE_DOCUMENT_FORMAT_FILE';
export const UPDATE_DOCUMENT_ACCESS_LEVEL_FILE =
  'UPDATE_DOCUMENT_ACCESS_LEVEL_FILE';
export const UPDATE_DOCUMENT_CONFERENCE_TYPE_FILE =
  'UPDATE_DOCUMENT_CONFERENCE_TYPE_FILE';
export const UPDATE_DOCUMENT_LEGAL_POSSIBILITY_FILE =
  'UPDATE_DOCUMENT_LEGAL_POSSIBILITY_FILE';
export const INSERT_CONFERENCE_TYPE_OPTIONS_DATA =
  'INSERT_CONFERENCE_TYPE_OPTIONS_DATA';
export const INSERT_LEGAL_POSSIBILITY_OPTIONS_DATA =
  'INSERT_LEGAL_POSSIBILITY_OPTIONS_DATA';
export const INSERT_DOCUMENT_TYPE_DOCUMENT_TABLE =
  'INSERT_DOCUMENT_TYPE_DOCUMENT_TABLE';
export const INSERT_DOCUMENT_TABLE_ROW_BY_DOCUMENT_TYPE =
  'INSERT_DOCUMENT_TABLE_ROW_BY_DOCUMENT_TYPE';
export const UPDATE_DOCUMENT_TABLE_BY_DOCUMENT_TYPE =
  'UPDATE_DOCUMENT_TABLE_BY_DOCUMENT_TYPE';
export const INSERT_TIPO_ATIVIDADES = 'INSERT_TIPO_ATIVIDADES';
export const INSERT_TIPO_ESCALAS = 'INSERT_TIPO_ESCALAS';
export const INSERT_TIPO_DOCUMENTOS = 'INSERT_TIPO_DOCUMENTOS';
export const INSERT_TIPOS_CONFERENCIA = 'INSERT_TIPOS_CONFERENCIA';
export const INSERT_HIPOTESES_LEGAL = 'INSERT_HIPOTESES_LEGAL';
export const INSERT_INFORMACAO_USUARIO = 'INSERT_INFORMACAO_USUARIO';
export const SET_STEP_INDEX = 'SET_STEP_INDEX';
export const UPDATE_TOTAL_CRONOGRAMA = 'UPDATE_TOTAL_CRONOGRAMA';
export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CLOSE_ALL_ALERTS = 'CLOSE_ALL_ALERTS';
export const SET_NOVA_SOLICITACAO_REQUERIMENTO =
  'SET_NOVA_SOLICITACAO_REQUERIMENTO';
export const SET_REQUERIMENTO_PROFUNDIDADE = 'SET_REQUERIMENTO_PROFUNDIDADE';
export const SET_COTA_MINIMA = 'SET_COTA_MINIMA';
export const SET_COTA_MAXIMA = 'SET_COTA_MAXIMA';
export const SET_SINAL_COTA_MINIMA = 'SET_SINAL_COTA_MINIMA';
export const SET_SINAL_COTA_MAXIMA = 'SET_SINAL_COTA_MAXIMA';
export const CLEAN_VALORES_COTAS = 'CLEAN_VALORES_COTAS';
export const INSERT_COORDENADAS = 'INSERT_COORDENADAS';
export const REMOVE_COORDENADA = 'REMOVE_COORDENADA';
export const CLEAN_COORDENADAS = 'CLEAN_COORDENADAS';
export const EDIT_COORDENADA = 'EDIT_COORDENADA';
export const UPDATE_COORDENADA = 'UPDATE_COORDENADA';
export const CANCEL_EDICAO_COORDENADA = 'CANCEL_EDICAO_COORDENADA';
export const SET_SUBSTANCIAS = 'SET_SUBSTANCIAS';
export const SET_SUPERFICIARIOS = 'SET_SUPERFICIARIOS';
export const SET_VISIBLE_LOADING = 'SET_VISIBLE_LOADING';
export const SET_DADOS_MAPA = 'SET_DADOS_MAPA';
export const SET_PAGAMENTO_SELECIONADO = 'SET_PAGAMENTO_SELECIONADO';
export const SET_LOADING_LOCAL = 'SET_LOADING_LOCAL';
export const INSERT_SUBSTANCIAS = 'INSERT_SUBSTANCIAS';
export const INSERT_SUPERFICIARIOS = 'INSERT_SUPERFICIARIOS';
export const SET_MUNICIPIOS = 'SET_MUNICIPIOS';
export const SET_ID = 'SET_ID';
export const SET_LOADING_MAPA = 'SET_LOADING_MAPA';
export const RESET_AREA_STATE = 'RESET_AREA_STATE';
export const RESET_MUNICIPIOS_STATE = 'RESET_MUNICIPIOS_STATE';
export const RESET_ATIVIDADES_STATE = 'RESET_ATIVIDADES_STATE';
export const RESET_RESPONSAVEIS_STATE = 'RESET_RESPONSAVEIS_STATE';
export const RESET_DADOS_MAPA = 'RESET_DADOS_MAPA';
export const INSERT_REPRESENTANTE = 'INSERT_REPRESENTANTE';
export const SET_CHANGE_COORDS = 'SET_CHANGE_COORDS';
export const SET_USER = 'SET_USER';
export const SET_USER_LOGGED = 'SET_USER_LOGGED';
export const SET_REPRESENTED_ID = 'SET_REPRESENTED_ID';
export const SET_REPRESENTED = 'SET_REPRESENTED';
export const SET_REPRESENTS = 'SET_REPRESENTS';
export const SET_USER_ACCESS = 'SET_USER_ACCESS';
export const SET_ATUALIZAR_DADOS_CADASTRAIS = 'SET_ATUALIZAR_DADOS_CADASTRAIS';
export const SET_USER_LOGGED_IN_TOKEN = 'SET_USER_LOGGED_IN_TOKEN';
export const SET_USER_VALID = 'SET_USER_VALID';
export const UPDATE_INFORMACAO_AREA_LIVRE = 'UPDATE_INFORMACAO_AREA_LIVRE';
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const LOADING_RESET = 'LOADING_RESET';